import React, { useState, useEffect, useRef } from "react";
import moment from "moment-timezone";
import './timmer.scss'

// Function to format time in days, hours, minutes, and seconds
const formatTime = (seconds) => {
  const days = isNaN(seconds) ? 0 : Math.floor(seconds / (24 * 60 * 60));
  const hours = isNaN(seconds) ? 0 : Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
  const mins = isNaN(seconds) ? 0 : Math.floor((seconds % (60 * 60)) / 60);
  const secs = isNaN(seconds) ? 0 : seconds % 60;

  return { days, hours, mins, secs };
};

// Reverse Timer component
const ReverseTimer = ({ closingDateTime, openingDateTime, isClosed = false }) => {
  const closingDate =
    closingDateTime && typeof closingDateTime === "string"
      ? moment
          .tz(closingDateTime, "YYYY-MM-DD HH:mm", "Asia/Kolkata")
          .toDate()
      : new Date(0);
  const currentTime = new Date(); // Current datetime
  const initialTime = isClosed ? 0 : Math.max(Math.floor((closingDate - currentTime) / 1000), 0); // Ensures no negative time

  const [timeLeft, setTimeLeft] = useState(initialTime);
  const intervalRef = useRef(null);

  useEffect(() => {
    // Clear any existing interval when starting fresh
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    // If auction is closed, immediately set to 0 and stop
    if (isClosed) {
      setTimeLeft(0);
      return;
    }

    // Recalculate time when closingDateTime or isClosed changes
    const newClosingDate =
      closingDateTime && typeof closingDateTime === "string"
        ? moment
            .tz(closingDateTime, "YYYY-MM-DD HH:mm", "Asia/Kolkata")
            .toDate()
        : new Date(0);
    const newTimeLeft = Math.max(Math.floor((newClosingDate - new Date()) / 1000), 0);
    setTimeLeft(newTimeLeft);

    if (newTimeLeft > 0) {
      intervalRef.current = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closingDateTime, openingDateTime, isClosed]);

  const { days, hours, mins, secs } = formatTime(timeLeft);

  // Conditional class for when the timer reaches zero
  const timerClass = timeLeft === 0 || isNaN(timeLeft) ? 'timer-zero' : '';

  return (
    <div className={`timer-container ${timerClass}`}>
      <div className="time-part">
        <span>{days}</span>
        <div className="time-label">Days</div>
      </div>
      <div className="time-part">
        <span>{hours.toString().padStart(2, "0")}</span>
        <div className="time-label">Hours</div>
      </div>
      <div className="time-part">
        <span>{mins.toString().padStart(2, "0")}</span>
        <div className="time-label">Minutes</div>
      </div>
      <div className="time-part">
        <span>{secs.toString().padStart(2, "0")}</span>
        <div className="time-label">Seconds</div>
      </div>
    </div>
  );
};

export default ReverseTimer;
